import { render, staticRenderFns } from "./CriarApresentante.vue?vue&type=template&id=84103d7a&scoped=true"
import script from "./CriarApresentante.vue?vue&type=script&lang=js"
export * from "./CriarApresentante.vue?vue&type=script&lang=js"
import style0 from "./CriarApresentante.vue?vue&type=style&index=0&id=84103d7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84103d7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84103d7a')) {
      api.createRecord('84103d7a', component.options)
    } else {
      api.reload('84103d7a', component.options)
    }
    module.hot.accept("./CriarApresentante.vue?vue&type=template&id=84103d7a&scoped=true", function () {
      api.rerender('84103d7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CriarApresentante.vue"
export default component.exports